<template>
    <b-img fluid :src="appLogoEmp" alt="Logo" />
</template>

<script>
import { BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
    components: {
        BImg,
    },
    setup() {
        const appLogoEmp = $themeConfig.logos.ilogo7
        return {
            appLogoEmp,
        }
    },
}
</script>
